'use strict';

var _toConsumableArray = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var debug = require('debug')('unicast-definition');

var EventEmitter = require('events');

var merge = require('lodash.merge');

var MUnicast = require('./messages/municast.js');
/**
 * Unicast component that simply sends messages to a neighbor.  It provides
 * easy-to-use event-like functions on top of a peer-sampling
 * protocol. Protocols can send messages using unicast.emit('eventName',
 * neighborId, args) and the neighbor can catch them using
 * unicast.on('eventName', args).
 */


var Unicast =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Unicast, _EventEmitter);

  /**
     * @param {IPSP} psp The peer-sampling protocol.
     * @param {object} [options] The options of this unicast.
     * @param {string} [options.pid = 'default-unicast'] The name of this
     * unicast.
     * @param {number} [option.retry = 0] The number of attempt to send a
     * message.
     */
  function Unicast(psp) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Unicast);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Unicast).call(this)); // #0 default options

    _this.options = merge({
      retry: 0,
      pid: 'default-unicast'
    }, options); // #1 create the table of registered protocols

    _this.psp = psp; // #2 overload the receipt of messages from the peer-sampling protocol

    var __receive = psp._receive;

    psp._receive = function (peerId, message) {
      try {
        __receive.call(psp, peerId, message);
      } catch (e) {
        if (message.type && message.type === 'MUnicast' && message.pid === _this.options.pid) {
          var _this2;

          (_this2 = _this)._emit.apply(_this2, [message.event].concat(_toConsumableArray(message.args)));
        } else {
          throw e;
        }

        ;
      }

      ;
    }; // #3 replace the basic behavior of eventemitter.emit


    _this._emit = _this.emit;
    /**
         * Send a message using the emit function.
         * @param {string} event The event name.
         * @param {string} peerId The identifier of the peer to send the event
         * to.
         * @param {object[]} [args] The arguments of the event.
         * @returns {Promise} Resolved if the message seems to have been sent,
         * rejected otherwise (e.g. timeout, unkown peers).
         */

    _this.emit = function (event, peerId) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return psp.send(peerId, new MUnicast(_this.options.pid, event, args), _this.options.retry);
    };

    debug('just initialized on top of %s@%s.', _this.psp.PID, _this.psp.PEER);
    return _this;
  }

  _createClass(Unicast, [{
    key: "destroy",

    /**
       * Destroy all listeners and remove the send capabilities
       */
    value: function destroy() {
      this.removeAllListener();
      this.emit = this._emit; // retrieve basic behavior
    }
  }]);

  return Unicast;
}(EventEmitter);

;
module.exports = Unicast;